import React from 'react';
import { RouteComponentProps } from '@reach/router';
import { useDemoModeStorage } from '@/hooks/useDemoModeStorage';

/**
 * デモモードのクエリパラメータの処理を行うコンポーネント
 *
 * - Router内で使用する
 */
export const DemoModeStorageHandler: React.FC<RouteComponentProps> = ({ children }) => {
    useDemoModeStorage();

    return <>{children}</>;
};
